import React from 'react';
import { Link } from 'react-router-dom';
import TableLoader from './TableLoader';

const SalasTable = ({ 
  salas, 
  loading
}) => {
  if (loading) {
    return <TableLoader />;
  }

  return (
    <div className="table-responsive">
      <table className="table align-items-center mb-0">
        <thead>
          <tr>
            <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Nome</th>
            <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cor</th>
            <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Ações</th>
          </tr>
        </thead>
        <tbody>
          {salas.map((sala) => (
            <tr key={sala.id}>
              <td className="text-xs mb-0">{sala.name}</td>
              <td className="text-xs mb-0">
                <div 
                  className="rounded-circle"
                  style={{ 
                    width: '30px', 
                    height: '30px', 
                    backgroundColor: sala.color,
                    border: '1px solid #dee2e6'
                  }}
                  title={sala.color}
                />
              </td>
              <td className="text-xs font-weight-bold mb-0">
                <Link to={`/Salas/Editar/${sala.id}`} title="Editar" className="me-3">
                  <i className="bi bi-pencil-square text-primary"></i>
                </Link>
                <Link to={`/Salas/Excluir/${sala.id}`} title="Excluir">
                  <i className="bi bi-trash text-danger"></i>
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SalasTable; 